<app-loader *ngIf="loading"></app-loader>

<div class="flex items-center justify-between gap-4 pb-8">
  <div class="relative w-72 transition-opacity" [class.opacity-0]="selection.length === 0">
    <app-select label="{{ 'page.project-detail-point-clouds.list.selected.label' | translate }}" [formControl]="downloadControl" [options]="downloadOptions"></app-select>

    <div class="absolute top-0 bottom-0 flex items-center right-8 text-primary-one transition-opacity" [class.opacity-0]="!downloading">
      <app-loader></app-loader>
    </div>
  </div>

  <app-button variant="plain" (click)="toggleAllSelected()" text="{{ (allSelected ? 'page.project-detail-photos.selected.deselect-all' : 'page.project-detail-photos.selected.select-all') | translate }}"></app-button>
</div>

<div *ngIf="photos$ | async as photos;">
  <div *ngIf="photos.length === 0">
    <p>{{ 'page.project-detail-photos.empty' | translate }}</p>
  </div>

  <div class="grid grid-cols-2 gap-4 md:grid-cols-4 lg:grid-cols-6">
    <div *ngFor="let photo of photos" class="bg-white rounded-2xl w-full shadow-card aspect-square cursor-pointer flex items-center justify-center relative overflow-hidden" (click)="openPhoto(photo)">
      <app-loader></app-loader>

      <img class="object-cover border-0 outline-0 object-center inset-0 absolute w-full h-full max-w-none" [attr.src]="photo | projectPhotoPreview | async" loading="lazy">

      <div class="absolute right-4 bottom-4 bg-white shadow-card p-1 rounded" (click)="deleteProjectPhoto(photo); $event.stopPropagation();">
        <app-button-icon icon="/assets/images/icon-trash.svg"></app-button-icon>
      </div>

      <div class="absolute left-4 top-4">
        <app-checkbox [formControl]="getSelectionControlForItem(photo)"></app-checkbox>
      </div>
    </div>
  </div>
</div>
